type TrashIconProps = {
  size?: number;
  color?: string;
  className?: string;
};

export const TrashIcon = ({ size = 24, color = "#231F20", className }: TrashIconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_1_167161)">
        <path
          d="M20.4726 4.96162H16.8028V4.09378C16.8028 2.93934 15.8635 2 14.7091 2H9.38224C8.22779 2 7.28846 2.93934 7.28846 4.09378V4.96162H3.619C3.277 4.96162 3 5.23863 3 5.58063C3 5.92262 3.277 6.19963 3.619 6.19963H4.58001V18.792C4.58001 20.5608 6.01919 22 7.78799 22H16.3039C18.0727 22 19.5119 20.5608 19.5119 18.792V6.19963H20.4729C20.8149 6.19963 21.0919 5.92262 21.0919 5.58063C21.0919 5.23863 20.8149 4.96162 20.4729 4.96162H20.4726ZM8.52677 4.09378C8.52677 3.62179 8.91055 3.23801 9.38254 3.23801H14.7094C15.1814 3.23801 15.5652 3.62179 15.5652 4.09378V4.96162H8.52677V4.09378ZM18.2736 18.792C18.2736 19.8781 17.39 20.762 16.3036 20.762H7.78799C6.70164 20.762 5.81801 19.8784 5.81801 18.792V6.19963H18.2736V18.792Z"
          fill={color}
        />
        <path
          d="M10.0145 8.92188C9.67251 8.92188 9.39551 9.19888 9.39551 9.54088V16.8392C9.39551 17.1812 9.67251 17.4582 10.0145 17.4582C10.3565 17.4582 10.6335 17.1812 10.6335 16.8392V9.54088C10.6335 9.19888 10.3565 8.92188 10.0145 8.92188Z"
          fill={color}
        />
        <path
          d="M14.3036 8.92188C13.9616 8.92188 13.6846 9.19888 13.6846 9.54088V16.8392C13.6846 17.1812 13.9616 17.4582 14.3036 17.4582C14.6456 17.4582 14.9226 17.1812 14.9226 16.8392V9.54088C14.9226 9.19888 14.6456 8.92188 14.3036 8.92188Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_1_167161">
          <rect width="18.0916" height="20" fill="white" transform="translate(3 2)" />
        </clipPath>
      </defs>
    </svg>
  );
};
